/** Textos oficiais dos códigos do leiaute da NFS-e Nacional (usados no DANFSe v2.0). */

export const OP_SIMP_NAC_LABEL: Record<string, string> = {
  '1': 'Não optante',
  '2': 'Optante - Microempreendedor Individual (MEI)',
  '3': 'Optante - Microempresa ou Empresa de Pequeno Porte (ME/EPP)'
};

export const REG_AP_TRIB_SN_LABEL: Record<string, string> = {
  '1': 'Regime de apuração dos tributos federais e municipal pelo Simples Nacional',
  '2': 'Regime de apuração dos tributos federais pelo SN e o ISSQN pela NFS-e conforme legislação municipal',
  '3': 'Regime de apuração dos tributos federais e municipal pela NFS-e conforme respectivas legislações federal e municipal de cada tributo'
};

export const TRIB_ISSQN_LABEL: Record<string, string> = {
  '1': 'Operação Tributável',
  '2': 'Imunidade',
  '3': 'Exportação de Serviço',
  '4': 'Não Incidência'
};

export const TP_RET_ISSQN_LABEL: Record<string, string> = {
  '1': 'Não Retido',
  '2': 'Retido pelo Tomador',
  '3': 'Retido pelo Intermediário'
};

export const TP_AMB_LABEL: Record<string, string> = {
  '1': 'Produção',
  '2': 'Produção Restrita (homologação — sem valor fiscal)'
};

/** `010501` → `01.05.01` */
export function formatCTribNac(v: string): string {
  const d = String(v ?? '').replace(/\D/g, '');
  return d.length === 6 ? `${d.slice(0, 2)}.${d.slice(2, 4)}.${d.slice(4, 6)}` : v;
}

/** `115062100` → `1.1506.21.00` */
export function formatNbs(v: string): string {
  const d = String(v ?? '').replace(/\D/g, '');
  return d.length === 9 ? `${d[0]}.${d.slice(1, 5)}.${d.slice(5, 7)}.${d.slice(7, 9)}` : v;
}

/** `4202305` → `42.02305` */
export function formatIbge(v: string): string {
  const d = String(v ?? '').replace(/\D/g, '');
  return d.length === 7 ? `${d.slice(0, 2)}.${d.slice(2)}` : v;
}
